import { Button } from '@veneer/core'
import React from 'react'

import { ENTRIES } from '@/constants/content-stack'
import { ErrorPrefix } from '@/constants/errors/prefix'
import type { ErrorCode } from '@/errors/classes/ErrorCode'
import { UnrecoverableErrorEntry } from '@/pages/UnrecoverableError/types'
import { UnrecoverableErrorPageAnalytics } from '@/pages/UnrecoverableError/UnrecoverableErrorPage.analytics'
import { useContentStack } from '@/services/content-stack'
import { dispatchNextStage } from '@/utils/dispatch-next-stage'

type ExitButtonProps = Readonly<{ error: ErrorCode }>

export const ERROR_DESCRIPTIONS: Record<string, string> = {
  [ErrorPrefix.CMS]: 'Unable to fetch content from CMS',
  DEPENDENCY: 'Unable to render page due to missing dependency',
}

export function ExitButton({ error }: ExitButtonProps) {
  const { entry } = useContentStack<UnrecoverableErrorEntry>({
    entryParams: ENTRIES.UNRECOVERABLE_ERROR,
    ensuresEntryFulfilled: true,
  })

  const clickHandler = () => {
    UnrecoverableErrorPageAnalytics.fireExitSetupButtonClicked()
    dispatchNextStage('failure', {
      errorCode: error.errorCode,
      errorDescription:
        ERROR_DESCRIPTIONS[error.getErrorCodeDetails().prefix!] ||
        ERROR_DESCRIPTIONS.DEPENDENCY,
    })
  }

  return (
    <Button
      data-testid="exit-setup"
      appearance="primary"
      onClick={clickHandler}
    >
      {entry.exitSetupButton}
    </Button>
  )
}
